import classNames from 'classnames'
import { useState } from 'react'

import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  children?: string
  className?: string
}

const Truncate = ({ children, className }: Props): ReactElement => {
  const [truncated, setTruncated] = useState(true)

  const toggleTruncate = () => setTruncated(!truncated)

  const isTextTooLong = children && children.length >= 200

  if (!isTextTooLong) {
    return <div className={className}>{children}</div>
  }

  return (
    <div className={classNames('truncate-component', className)}>
      <p>{truncated ? `${children?.slice(0, 200)}...` : children}</p>
      <div className="see-more-label" onClick={toggleTruncate} role="toggleTruncate">
        {truncated ? 'See more' : 'See less'}
      </div>
    </div>
  )
}

export default Truncate
